import {
  GET_WORKFLOW_TYPES_PENDING,
  GET_WORKFLOW_TYPES_FULFILLED,
  GET_WORKFLOW_TYPES_REJECTED,
  RESET_STATES,
} from "../actions/types";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_WORKFLOW_TYPES_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_WORKFLOW_TYPES_FULFILLED:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
      };
    case GET_WORKFLOW_TYPES_REJECTED:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case RESET_STATES:
      return {
        ...state,
        data: [],
      };
    default:
      return state;
  }
}
